<template>
  <div id="app">
    <headertop></headertop>
    <div class="main">
      <h1>文档资源</h1>
      <el-row style="float: right;">
          <router-link :to="{path:'/visitor_filetow?num=0'}" target="_blank" style="">新版体验</router-link>
      </el-row>
      <div class="filetree">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText">
        </el-input>

        <el-tree class="filter-tree" :data="treeList"  :props="defaultProps" default-expand-all
          :filter-node-method="filterNode" ref="tree" @node-click="handleNodeClick" >
        </el-tree>
      </div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    name: 'App',
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    data() {
      return {
        filterText: '',
        treeList:[],
        defaultProps: {
          children: 'child',
          label: 'name'
        }
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted: function () {
      this.get_info();
    },
    methods: {
      //初始化
      get_info() {
        let _this = this;
        _this.axios
          .get("/v2/temp/get_file", {
          params: {type:'file'}})
          .then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                  _this.treeList=res.data.data

              } else {
                _this.$message.error("服务器内部错误");
              }
            } else {
              _this.$message.error("服务器内部错误");
            }
          });
      },

      filterNode(value, data) {
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },

    //  handleNodeClick(data) {
    //   if(data.hasOwnProperty('file')){
    //    this.$router.push({path:'/FileQCregister',query:{num:data.file}})
    //   }

    // },

    }}

</script>

<style scoped>
  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;

  }

  h1 {
    margin: 20px;
  }

  .filetree {
    width: 90%;
    margin: 0 5%;
  }
  .el-input{
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/File/File.vue